<!-- eslint-disable -->
<template lang="pug">
    drop-down-slider(
        v-if="answers.length || gameStarted"
        :game-started="gameStarted"
        :game-mode="gameMode"
        :items-length="answers.length"
    )
        .link(
            v-for="(item, index) in answers",
            :key='index'
        )
            drag.answers-container__drag(
                v-if="linksType === 'image' && item.type !== 'dropZone'"
                :draggable="gameStarted && item.type !== 'correct-link'"
                :transfer-data="{ item: item, index: index, from: 'answers-box'}"
                @dragstart="$emit('dragStarted')"
                @dragend="$emit('dragEnded')"
            )
                img(
                    class="answer"
                    :class="{ 'answer_correct': item.type === 'correct-link' }",
                    :src='item.value | apiFile',
                    :data-index='index'
                    :draggable="gameStarted && item.type !== 'correct-link'"
                )
</template>

<script>
    /*eslint-disable*/
    import { Drag, Drop } from 'vue-drag-drop';
    import DropDownSlider from "@/components/trainer/games/DropDownSlider.vue";
    const DEFAULT_VOLUME = 0.6;

    export default {
        props: {
            answers: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            gameStarted: Boolean,
            gameMode: String,
            linksType: String,
            dragStarted: Boolean,
            helperModeOn: Boolean,
            itemsLength: {
                type: Number,
                default: 3
            }
        },
        data () {
            return {
                showingIndex: 0,
                soundInstance: null,
                isInputFocused: false,
            }
        },
        watch: {
            dragStarted (value) {
                let shakeZone = document.querySelectorAll('.drop-zone__shake-zone');
                let amount = shakeZone.length;
                let timeouts = [];
                if (value && shakeZone) {
                    for (let i = 0; i < amount; i++) {
                        timeouts.push(setTimeout(() => {
                            shakeZone[i].classList.add('shake');
                        }, i * 100));
                    }
                    setTimeout(() => {
                        for(let j = 0; j < timeouts.length; j++) {
                            clearTimeout(timeouts[j]);
                        }
                        for (let i = 0; i < amount; i++) {
                            if (shakeZone[i]) {
                                shakeZone[i].classList.remove('shake');
                            }
                        }
                    }, 2000)
                }
            }
        },
        updated () {
            this.isInputFocused = this.helperModeOn === true ? false : this.isInputFocused;
            if (!this.isInputFocused && this.$refs.input && this.$refs.input[0]) {
                this.$refs.input[0].blur();
                this.focusNextElement();
            }
        },
        methods: {
            focusInput (event) {
                this.isInputFocused = this.$refs.input.some(element => _.isEqual(element, event.target));
            },
            focusNextElement(index = 0) {
                let uncompletedItems = this.answers.filter(item => item.type === "textInput");
                let completedItems = this.answers.filter((item, itemIndex) => item.type !== "textInput" && itemIndex < index);
                index = index - completedItems.length;
                index = index >= uncompletedItems.length ? index % uncompletedItems.length : index;
                let isChainCompleted = !this.answers.some(item => item.value === '');
                if (isChainCompleted) {
                    this.isInputFocused = false;
                    this.$emit('processReply');
                } else if (this.$refs.input[index]) {
                    this.$refs.input[index].focus();
                }
            },
        },
        computed: {
            itemValue () {
                return this.answers[this.showingIndex].value;
            },
        },
        components: {
            DropDownSlider,
            Drag,
            Drop
        }
    }
</script>

<style lang="scss" scoped>
    .answers-container__drag {
        position: relative;
        width: 100%;
        height: 0;
        padding-top: 0;
        padding-bottom: 100%;
    }

    .answer {
        border: 1px solid $color-grey-600;
        border-radius: 12px;
        cursor: grab;
        position: absolute;
        left: 0;
        height: auto;
    }

    .link {
        display: inline-flex;
        align-items: center;
        width: 10%;
        height: 100%;
        padding: 0 10px;
        box-sizing: border-box;
    }

    .link:last-child {
        margin-right: 3%;
    }

    .drop-zone {
        display: inline-flex;
    }

    .drop-zone__shake-zone {
        width: 200px;
        height: 200px;
        margin: auto;
        background: white;
        border: 1px solid $color-green-500;
        border-radius: 12px;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
